import queryString from 'query-string';

import { InterceptedAxios } from 'api/utils/axios-instances';
import { DEFAULT_PAGE_SIZE } from 'constants/table';
import { API_ROOT } from 'api/constants';
import { DEFAULT_BRAND_SEARCH } from 'constants/brands';

import {
  IBrands,
  IBrandsOptions,
  IDepartments,
  IDepartmentsOptions,
  IItem,
  IItems,
  ISearchOptions,
} from '../models';

export class CatalogService {
  static search = ({
    q = '*',
    page = 0,
    size = DEFAULT_PAGE_SIZE,
    ...options
  }: ISearchOptions) => {
    const recombined = { q: q || '*', page, size, ...options };
    console.log('executing search: ', recombined);
    return InterceptedAxios.get<IItems>(
      `${API_ROOT}/search?${queryString.stringify(recombined, {
        arrayFormat: 'comma',
      })}`
    );
  };

  static getBrands = ({
    brandRegex = DEFAULT_BRAND_SEARCH,
    ...options
  }: IBrandsOptions) => {
    const recombined = {
      brandRegex: brandRegex || DEFAULT_BRAND_SEARCH,
      ...options,
    };
    console.log('executing getBrands: ', recombined);
    return InterceptedAxios.get<IBrands>(
      `${API_ROOT}/brands?${queryString.stringify(recombined, {
        arrayFormat: 'comma',
      })}`
    );
  };

  static getDepartments = (options: IDepartmentsOptions) => {
    console.log('executing getDepartments: ', options);
    return InterceptedAxios.get<IDepartments>(
      `${API_ROOT}/departments?${queryString.stringify(options, {
        arrayFormat: 'comma',
      })}`
    );
  };

  static getItemDetails = (itemNumber: string) => {
    console.log('executing  getItemDetails: ', itemNumber);
    return InterceptedAxios.get<IItem>(`${API_ROOT}/items/${itemNumber}`);
  };
}
